import { BasisPoints } from '@klear/basis-points'
import { Money } from '@klear/money'

export type FeeAllocationJson = {
  feeId: number
  orderId: number
  beneficiary: string
  beneficiaryId: number
  amount: Money
  rateUsed: number
}

export class FeeAllocation {
  static readonly __klearClass = 'FeeAllocation'

  readonly feeId: number
  readonly orderId: number
  readonly beneficiary: string
  readonly beneficiaryId: number
  readonly amount: Money
  readonly rateUsed: BasisPoints

  constructor(props: FeeAllocationJson) {
    this.feeId = props.feeId
    this.orderId = props.orderId
    this.beneficiary = props.beneficiary
    this.beneficiaryId = props.beneficiaryId
    this.amount = props.amount
    this.rateUsed = FeeAllocation.resolveRateUsed(props.rateUsed, this.beneficiary)
  }

  get key(): string {
    return `${this.feeId}:${this.beneficiary}`
  }

  toJSON(): FeeAllocationJson {
    return {
      feeId: this.feeId,
      orderId: this.orderId,
      beneficiary: this.beneficiary,
      beneficiaryId: this.beneficiaryId,
      amount: this.amount,
      rateUsed: this.rateUsed.value
    }
  }

  private static resolveRateUsed(rateUsed: number, beneficiary: string): BasisPoints {
    return beneficiary === 'klear' ? BasisPoints.signed(rateUsed) : new BasisPoints(rateUsed)
  }
}
